import { Avatar, Badge, Icon, Typography } from '@sravni/react-design-system';
import { Verification } from '@sravni/react-icons';
import type IProduct from '@sravni/vitrina/lib/types/IProduct';
import cn from 'classnames';
import React from 'react';

import style from './TopOffersRow.module.scss';

type Props = {
  product: IProduct;
  defaultLink?: string;
};

export const TopOffersRow: FC<Props> = (props) => {
  const { product, defaultLink } = props;

  const { alias, advertising, logo, organization } = product;
  const link = advertising?.monetization?.pixels.click;

  return link ? (
    <div className={style.content}>
      {product.isPartner ? (
        <Badge
          variant="primary"
          className={style.badge}
          color="light"
          text={
            <Icon
              size={20}
              color="blue"
              icon={<Verification />}
            />
          }
          shape="circle"
          placement="bottom-end"
        >
          <Avatar
            className={cn(style.logo, style.isPartner)}
            src={logo}
            size={36}
          />
        </Badge>
      ) : (
        <Avatar
          className={cn(style.logo)}
          src={logo}
          size={36}
        />
      )}
      <Typography.Link
        href={defaultLink || link}
        target="_blank"
        key={alias}
      >
        {organization.name.short}
      </Typography.Link>
    </div>
  ) : (
    <div className={style.content}>
      {product.isPartner ? (
        <Badge
          variant="primary"
          color="light"
          className={style.badge}
          text={
            <Icon
              size={20}
              color="blue"
              icon={<Verification />}
            />
          }
          shape="circle"
          placement="bottom-end"
        >
          <Avatar
            className={cn(style.logo, style.isPartner)}
            src={logo}
            size={36}
          />
        </Badge>
      ) : (
        <Avatar
          className={style.logo}
          src={logo}
          size={36}
        />
      )}

      {defaultLink ? (
        <Typography.Link
          target="_blank"
          href={defaultLink}
        >
          {organization.name.short}
        </Typography.Link>
      ) : (
        <span>{organization.name.short}</span>
      )}
    </div>
  );
};
